import { render, staticRenderFns } from "./invite_relationships.vue?vue&type=template&id=3a06ea78&"
import script from "./invite_relationships.vue?vue&type=script&lang=js&"
export * from "./invite_relationships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports